import axios from "axios";
import { useInfiniteQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const notes = async (data: NotesReqT) => {
  const { pageParam, title, customerId, mySelf } = data;

  const qs = `?page=${pageParam ?? 1}&title=${title ?? ""}&my_self=${
    mySelf ?? ""
  }&customer_id=${customerId ?? ""}`;

  return axios.get(Routes.NOTES + qs);
};

export const useNotes = (params: NotesReqT) => {
  const { title, customerId } = params;
  return useInfiniteQuery({
    queryKey: [Keys.NOTES_QRY, title, customerId],
    queryFn: ({ pageParam = 1 }) => notes({ pageParam, ...params }),
    getNextPageParam: (lastPage) => {
      return lastPage.data.links.next
        ? lastPage.data.meta.current_page + 1
        : null;
    },
    getPreviousPageParam: (firstPage) => firstPage.data.links.prev,
    cacheTime: 0,
  });
};
